import { useEffect, useState } from "react";
import { Menu } from "lucide-react";
import Sidebar from "./Sidebar";
import Header from "./MainDashboard/Header";
import { Outlet, useLocation } from "react-router-dom";
import { useGlobalContext } from "../GlobalContext";
import LogoutWatcher from "./Utils/LogoutWatcher";
import AccessDeniedPage from "./Utils/AccessDeniendPage";

export default function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const {
    showOld,
    setShowOld,
    isAccessDenied,
    setIsAccessDenied,
    accessDeniedMessage,
    setAccessDeniedMessage,
  } = useGlobalContext();

  useEffect(() => {
    setIsAccessDenied(false);
    setAccessDeniedMessage("");
  }, [location.pathname, setIsAccessDenied, setAccessDeniedMessage]);

  // Close the mobile drawer automatically on route change
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  const currentPath = location.pathname.toLowerCase();

  const isAdminAccessPage =
    currentPath === "/admin" ||
    currentPath.startsWith("/admin/") ||
    currentPath === "/admin-access" ||
    currentPath.startsWith("/admin-access/");

  return (
    <div className="flex h-dvh min-h-0 w-full overflow-hidden bg-slate-50">
      <LogoutWatcher type="admin" />

      {/* Mobile backdrop, shown only when the drawer is open */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar: fixed/off-canvas drawer on mobile, static in-flow on desktop */}
      <div
        className={`fixed inset-y-0 left-0 z-[999] h-dvh w-64 transform transition-transform duration-300 ease-in-out
          lg:static lg:z-auto lg:h-auto lg:w-auto lg:translate-x-0
          ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}`}
      >
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      </div>

      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <div className="shrink-0 flex items-center bg-yellow-50">
          {/* Hamburger — mobile only */}

          <button
            type="button"
            onClick={() => setSidebarOpen(true)}
            className="lg:hidden p-2 ml-1 rounded bg-yellow-50 hover:bg-orange-100 shrink-0"
            aria-label="Open menu"
          >
            <Menu className="w-5 h-5 text-orange-600" />
          </button>
          <div className="flex-1 min-w-0">
            <Header showOld={showOld} setShowOld={setShowOld} />
          </div>
        </div>

        {isAccessDenied ? (
          <main className="min-h-0 min-w-0 flex-1 overflow-y-auto bg-slate-50 p-2">
            <AccessDeniedPage
              message={accessDeniedMessage || "Access Denied"}
              subMessage="You do not have permission to access this section."
            />
          </main>
        ) : isAdminAccessPage ? (
          <main className="relative flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-slate-50 p-2">
            <div className="relative min-h-0 min-w-0 flex-1 overflow-hidden">
              <Outlet />
            </div>
          </main>
        ) : (
          <main className="relative flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-slate-50 p-2">
            <div className="relative min-h-0 min-w-0 flex-1 overflow-auto">
              <Outlet />
            </div>
          </main>
        )}
      </div>
    </div>
  );
}